import People from '@crehana/icons/outline/People';
import PlaySquare from '@crehana/icons/outline/PlaySquare';
import Routes from '@crehana/icons/outline/Routes';
import Stats from '@crehana/icons/outline/Stats';

import { OrganizationReportGenerationWeekDayEnum } from '@/shared/types/graphql/globals.v4.b2b';

export const USER_STATES = [
  {
    label: 'REPORTS_SELECT_USERSTATE_INPUT_LABEL_1',
    value: 'STATUS_USERS_PENDING',
  },
  {
    label: 'REPORTS_SELECT_USERSTATE_INPUT_LABEL_2',
    value: 'STATUS_USERS_ACTIVE',
  },
  {
    label: 'REPORTS_SELECT_USERSTATE_INPUT_LABEL_3',
    value: 'STATUS_USERS_INACTIVE',
  },
  {
    label: 'REPORTS_SELECT_USERSTATE_INPUT_LABEL_4',
    value: 'STATUS_USERS_DELETE',
  },
];
export const USER_ROLES = [
  {
    label: 'REPORTS_SELECT_USERSROLE_INPUT_LABEL_1',
    value: 'ROLE_MEMBERS',
  },
  {
    label: 'REPORTS_SELECT_USERSROLE_INPUT_LABEL_2',
    value: 'ROLE_ADMIN',
  },
];
export const SHEET_TYPES = [
  {
    label: 'REPORTS_TYPE_GENERAL_INCLUDE_INFO_1_1',
    value: 'COURSE_SHEET',
  },
  {
    label: 'REPORTS_TYPE_GENERAL_INCLUDE_INFO_2_1',
    value: 'ACTIVITY_SHEET',
  },
  {
    label: 'REPORTS_TYPE_GENERAL_INCLUDE_INFO_3_1',
    value: 'GENERAL_SHEET',
  },
  {
    label: 'REPORTS_TYPE_GENERAL_INCLUDE_INFO_4_1',
    value: 'PERFORMANCE_SHEET',
  },
];
export const REPORT_FORMATS = [
  {
    label: 'REPORTS_PREFS_FORMAT_1',
    value: 'XLSX_FORMAT',
  },
];
export const REPORT_DOWNLOAD_MODE = [
  {
    label: 'REPORTS_PREFS_DOWNLOAD_1',
    value: false,
  },
  {
    label: 'REPORTS_PREFS_DOWNLOAD_2',
    value: true,
  },
];
export const REPORT_TYPE = [
  {
    label: 'REPORTS_TYPE_SELECTOR_TITLE_0',
    value: 'REPORT_B2B_GENERAL',
  },
  {
    label: 'REPORTS_TYPE_SELECTOR_TITLE_1',
    value: 'REPORT_B2B_TRACKS',
  },
  {
    label: 'REPORTS_TYPE_SELECTOR_TITLE_2',
    value: 'REPORT_B2B_COURSES',
  },
  {
    label: 'REPORTS_TYPE_SELECTOR_TITLE_3',
    value: 'REPORT_B2B_USERS',
  },
  {
    label: 'REPORTS_TYPE_SELECTOR_TITLE_4',
    value: 'REPORT_B2B_LEADERS',
  },
];

export const MAX_INPUT_LENGHT = {
  NAME: 30,
  DESC: 50,
};

export const DIALOG_SUCCESS_ICON =
  'https://crehana-vercel-images-prd.imgix.net/public/e0e04625-2329-4cf9-8b36-d7ff2551cc6f-group-14344-(1).png?auto=format&fit=clip';

export const REPORT_TYPE_ICONS: React.FC[] = [
  Stats,
  Routes,
  PlaySquare,
  People,
];

export const FEEDBACK_URL = 'https://crehana.typeform.com/to/Wdqk1MJI';

export const WEEKLY_DAYS = [
  {
    label: 'SCHEDULE_GENERATION_FREQ_INPUT_LABEL_WEEKLY_0',
    value: OrganizationReportGenerationWeekDayEnum.MONDAY,
  },
  {
    label: 'SCHEDULE_GENERATION_FREQ_INPUT_LABEL_WEEKLY_1',
    value: OrganizationReportGenerationWeekDayEnum.TUESDAY,
  },
  {
    label: 'SCHEDULE_GENERATION_FREQ_INPUT_LABEL_WEEKLY_2',
    value: OrganizationReportGenerationWeekDayEnum.WEDNESDAY,
  },
  {
    label: 'SCHEDULE_GENERATION_FREQ_INPUT_LABEL_WEEKLY_3',
    value: OrganizationReportGenerationWeekDayEnum.THURSDAY,
  },
  {
    label: 'SCHEDULE_GENERATION_FREQ_INPUT_LABEL_WEEKLY_4',
    value: OrganizationReportGenerationWeekDayEnum.FRIDAY,
  },
  {
    label: 'SCHEDULE_GENERATION_FREQ_INPUT_LABEL_WEEKLY_5',
    value: OrganizationReportGenerationWeekDayEnum.SATURDAY,
  },
  {
    label: 'SCHEDULE_GENERATION_FREQ_INPUT_LABEL_WEEKLY_6',
    value: OrganizationReportGenerationWeekDayEnum.SUNDAY,
  },
];
